export const SPECIAL_ACADEMY_CLUSTERS = [
  { id: "special-mpsc", name: "Maharana Pratap Sports College" },
  { id: "special-shstsc", name: "Shri Hari Singh Thapa Sports College" },
  { id: "special-mslsc", name: "Mahila Sports College Lohaghat" },
];
